/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Logo from "../assets/images/logo.svg";
import { business, footer } from "../data";

const Footer = () => {
	const { social, copyright } = footer;
	const socialLink = social.map((item, index) => {
		const { icon, href } = item;
		return (
			<div
				key={index}
				className='w-12 h-12 text-white text-2xl rounded-full bg-gray-700 hover:bg-accent flex justify-center items-center transition'
			>
				<a href={href} target='_blank' rel='noreferrer'>{icon}</a>
			</div>
		);
	});
	return (
		<footer className='section bg-primary'>
			<div className='container mx-auto'>
				<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 border-b border-opacity-75 border-gray-700 pb-7 lg:pb-14 mb-14'>
					
					{/* Column 1: Logo and Description */}
					<div className='flex flex-col items-center md:items-start'>
						<a href='#' className='flex flex-col items-center md:items-center'>
							<img src={Logo} alt='Logo' className='w-45 h-36' />
							<span className="text-yellow-400 text-sm tracking-[4px] uppercase mt-1">
							
							</span>
						</a>
					
					</div>

					{/* Column 2: Quick Links */}
					<div className='text-center md:text-left'>
						<h3 className='text-white text-lg font-semibold mb-4'>Quick Links</h3>
						<ul className='space-y-2'>
							<li><a href='#home' className='text-gray-400 hover:text-yellow-400 transition'>Home</a></li>
							<li><a href='#about' className='text-gray-400 hover:text-yellow-400 transition'>About Us</a></li>
							<li><a href='#features' className='text-gray-400 hover:text-yellow-400 transition'>Features</a></li>
							<li><a href='#contact' className='text-gray-400 hover:text-yellow-400 transition'>Contact</a></li>
						</ul>
					</div>

					{/* Column 3: Contact Info */}
					<div className='text-center md:text-left'>
						<h3 className='text-white text-lg font-semibold mb-4'>Contact Us</h3>
						<ul className='space-y-3 text-gray-400'>
							<li className='flex items-center justify-center md:justify-start gap-2'>
								<svg className="w-5 h-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
								</svg>
								<span>{business.whatsapp}</span>
							</li>
							<li className='flex items-center justify-center md:justify-start gap-2'>
								<svg className="w-5 h-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
								</svg>
								<span>{business.address}</span>
							</li>
							<li className='flex items-center justify-center md:justify-start gap-2'>
								<svg className="w-5 h-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
								</svg>
								<a href={`mailto:kohlanews@gmail.com`} className='hover:text-yellow-400 transition'>
									kohlanews@gmail.com
								</a>
							</li>
						</ul>
					</div>

					{/* Column 4: Social Links */}
					<div className='text-center md:text-left'>
						<h3 className='text-white text-lg font-semibold mb-4'>Follow Us</h3>
						<div className='flex gap-3 justify-center md:justify-start'>
							{socialLink}
						</div>
						<div className='mt-4'>
							<a 
								href={business.mapLink} 
								target='_blank' 
								rel='noreferrer'
								className='inline-block bg-accent hover:bg-opacity-80 text-white px-4 py-2 rounded text-sm transition'
							>
								📍 Find Us on Google Maps
							</a>
						</div>
					</div>

				</div>
				<div className='text-white text-center'>&copy; {copyright}</div>
			</div>
		</footer>
	);
};

export default Footer;